import classnames from 'classnames';
import React from 'react';

import {Text} from '@albert-io/atomic';

interface Props {
  title: string;
  /** The group's scope total, not the union in the status control; omitted while it is unknown. */
  count?: number;
  children: React.ReactNode;
}

/**
 * A titled, counted section of the Skill Paths tab's lists (e.g. "Diagnostics (10)").
 */
export const SkillPathListGroup = ({title, count, children}: Props) => (
  <section className='gap-x1 flex flex-col'>
    <Text as='h3' className='m-x0 font-black' size='s'>
      {title}{' '}
      {count !== undefined && <span className='content-tertiary font-normal'>({count})</span>}
    </Text>
    {children}
  </section>
);

/**
 * The bordered panel a group falls back to when it has no rows, so an empty section still reads as
 * a section rather than letting the two group headings collapse together.
 *
 * Owns the inset for both shapes it hosts, since `EmptyState`'s inline layout adds none: a line of
 * copy sits tighter than a full illustrated state.
 */
export const SkillPathListGroupEmpty = ({
  children,
  inset = 'text'
}: {
  children: React.ReactNode;
  inset?: 'text' | 'panel';
}) => (
  <div
    className={classnames(
      'rounded-x1 border-primary border',
      inset === 'panel' ? 'p-x2' : 'px-x2 py-x1-half'
    )}
  >
    {children}
  </div>
);
